/** In-app path to start signing for a document (single vs combined). */
export const signPathForDocument = (
  signId: string,
  isCombinedDocument?: boolean
) => (isCombinedDocument ? `/sign-combined/${signId}` : `/sign/${signId}`);
